<template>
  <div class="devices is-margin-top">

    <section>
      <div class='container'>

        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li class="is-active">
              <button id='refresh_button' class="button" @click='fetch_data()'>
                <b-icon icon="refresh"></b-icon>
              </button>
              <a href="#/tests" aria-current="page">&nbsp;&nbsp;Список Машин</a>
            </li>
            </ul>
        </nav>
        
        <b-tabs v-model="activeTab" :animated='false'>

          <b-tab-item label="Список">
            <div class="columns is-margin-top">

              <div class="column is-two-thirds"> 
                <b-table :data='cars' :selected.sync='selected_car' :loading='data_loading' paginated>
                  <template slot-scope="props">

                    <b-table-column field="name" label="Название" width="100" sortable>
                      {{ props.row.name }}
                    </b-table-column>

                    <b-table-column field="car_type" label="Тип" width="120" sortable>
                      {{ dict_car_type[props.row.car_type] }}
                    </b-table-column>

                    <b-table-column field="size" label="Размер" width="150" sortable>
                      {{ dict_car_size[props.row.size] }}
                    </b-table-column>

                    <b-table-column field="number" label="Номер" width="200" sortable number>
                      {{ props.row.number }}
                    </b-table-column>

                    <b-table-column field="active" label="Активна" width="80" sortable boolean>
                      <b-checkbox disabled v-model='props.row.active'></b-checkbox>
                    </b-table-column>

                  </template>
                </b-table>
              </div>

              <div class='column is-one-third'>
                <section class='is-margin-top box fast_edit'>
                  <b-tabs class="block" v-if='selected_car.hasOwnProperty("_id")' :animated='false'>
                    <b-tab-item label='Основные'>
                      <b-field label="Название">
                        <b-input v-model="selected_car.name"></b-input>
                      </b-field>
                      <b-field label="Тип машины">
                        <b-select expanded placeholder="Выберите тип машины" v-model='selected_car.car_type'>
                          <option
                              v-for="option in car_types"
                              :value="option.value"
                              :key="option.value">
                              {{ option.label }}
                          </option>
                        </b-select>
                      </b-field>
                      <b-field label="Размер машины">
                        <b-select expanded placeholder="Выберите размер машины" v-model='selected_car.size'>
                          <option
                              v-for="option in car_sizes"
                              :value="option.value"
                              :key="option.value">
                              {{ option.label }}
                          </option>
                        </b-select>
                      </b-field>
                      <b-field label="Активна?">
                        <b-switch v-model="selected_car.active"></b-switch>
                      </b-field>
                    </b-tab-item>                
                    <b-tab-item label='Номер'>
                      <div class="card">
                          <header class="card-header">
                            <p class="card-header-title">
                              Карта
                            </p>
                          </header>
                          <div class="card-content">
                            <div v-if='selected_car.number === "0"'>
                              Карта не привязана
                            </div>
                            <div v-else>
                              Номер карты: {{ selected_car.number }}
                            </div>
                          </div>
                          <footer class="card-footer">
                            <a class='card-footer-item' @click='is_waiting_for_card=true;reader_target=selected_car'>Перепривязать карту</a>
                          </footer>
                        </div>
                    </b-tab-item>  
                    <b-tab-item label='Статус'>
                      {{ selected_car.state }}
                    </b-tab-item>
                    <button class='button is-margin-top' @click='save_car'>Сохранить</button>  
                  </b-tabs>
                  <div v-else class='is-margin-top notification'>
                    Выберите устройство для быстрого редактирования.
                  </div>
                </section>
              </div>
            </div>
          </b-tab-item>

          <b-tab-item label="+ Добавить">
            <div class="columns">

              <div class="column">
                <div class="card">
                  <div class='card-content'>

                    <b-field label="Название">
                      <b-input v-model="new_car.name"></b-input>
                    </b-field>
                    
                    <b-field label="Тип машины">
                      <b-select expanded placeholder="Выберите тип машины" v-model='new_car.car_type'>
                        <option
                            v-for="option in car_types"
                            :value="option.value"
                            :key="option.value">
                            {{ option.label }}
                        </option>
                      </b-select>
                    </b-field>

                     <b-field label="Размер машины">
                      <b-select expanded placeholder="Выберите размер машины" v-model='new_car.size'>
                        <option
                            v-for="option in car_sizes"
                            :value="option.value"
                            :key="option.value">
                            {{ option.label }}
                        </option>
                      </b-select>
                    </b-field>

                    <b-field label="Аквивна?">
                      <b-switch v-model="new_car.active"></b-switch>
                    </b-field>

                  </div>
                </div>
              </div>

              <div class="column">
                <div class="card">
                  <div class='card-content'>

                    <div class="content">
                        <div v-if='new_car.number === "0"' class="notification">
                          Карта не привязана
                        </div>
                        <div v-else  class="notification">
                          Номер: {{ new_car.number }}
                        </div>
                        <button class='button' @click='is_waiting_for_card=true;reader_target=new_car'>Привязать карту</button>
                    </div>

                  </div>
                </div>
              </div>

              <div class="column">
                <div class="card">
                  <div class='card-content'>
                    <div class='is-margin-bottom'>
                      <button class='button' @click='add_car'>Сохранить</button>
                    </div>
                    <div>
                      <button class='button' @click='reset_new_form'>Сбросить форму</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </b-tab-item>

        </b-tabs>

      </div>
    </section>

    <b-modal :active.sync="is_waiting_for_card" :width="320" scroll="keep">
      <div class='card'>
        <div class='card-content text-center'>
          <div class='is-margin-bottom'>
            <img src='static/images/icons8-foul-64.png' />
          </div>
          <div class='is-margin-bottom'>
            Приложите карту к считывателю
          </div>
        </div>
        <footer v-if='store.state.debug' class="card-footer">
           <a class='card-footer-item' @click='reader_read({ card_number: String(Math.floor(Math.random()*100000000000)) })'>Случайный номер</a>
           <a class='card-footer-item' @click='reader_read({ card_number: "80000000001" })'>Карта 1</a>
           <a class='card-footer-item' @click='reader_read({ card_number: "80000000002" })'>Карта 2</a>
           <a class='card-footer-item' @click='reader_read({ card_number: "80000000003" })'>Карта 3</a>
        </footer>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import { EventBus } from '../bus'
  import store from '../store'

  export default {
    name: 'cars',
    data () {
      this.$parent.active_tab = 'cars'
      EventBus.$on('ws_on_message', this.ws_on_message)
      this.fetch_data()
      return {
        store: store,
        cars: [],
        data_loading: true,
        empty_new_car: {name: '', car_type: '', active: false, size: '', number: '0'},
        new_car: {name: '', car_type: '', active: false, size: '', number: '0'},
        selected_car: {},
        activeTab: '',
        is_waiting_for_card: false,
        reader_target: null,
        car_types: [{value: 'manual', label: 'Вело'}, {value: 'electro', label: 'Электро'}],
        car_sizes: [{value: 'small', label: 'Маленькая'}, {value: 'middle', label: 'Средняя'}, {value: 'big', label: 'Большая'}],
        dict_car_size: {'small': 'Маленькая', 'middle': 'Средняя', 'big': 'Большая'},
        dict_car_type: {'manual': 'Вело', 'electro': 'Электро'}
      }
    },
    methods: {
      fetch_data: function () {
        var t = this
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_get_cars', params: {}})
        window.$.post(window.gw + 'api/car', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.cars = d.params.cars
            t.data_loading = false
          }
        })
        return
      },
      save_car: function () {
        var _t = this
        _t.data_loading = true
        var form = JSON.stringify({method: 'admin_save_car', params: {car: _t.selected_car}})
        window.$.post(window.gw + 'api/car', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            _t.data_loading = false
            _t.$toast.open({
              duration: 1000,
              message: 'Готово!',
              position: 'is-top',
              type: 'is-success'
            })
          }
        })
        return
      },
      add_car: function () {
        var _t = this
        if (_t.new_car.name === '') { _t.new_car_required_error(); return }
        if (_t.new_car.size === '') { _t.new_car_required_error(); return }
        if (_t.new_car.car_type === '') { _t.new_car_required_error(); return }
        if (_t.new_car.number === '0') { _t.new_car_required_error(); return }

        _t.data_loading = true
        var form = JSON.stringify({method: 'admin_add_car', params: {new_car: _t.new_car}})
        window.$.post(window.gw + 'api/car', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            _t.data_loading = false
            _t.$toast.open({
              duration: 1000,
              message: 'Готово!',
              position: 'is-top',
              type: 'is-success'
            })
            _t.reset_new_form()
            _t.fetch_data()
          }
        })

        return
      },
      new_car_required_error: function () {
        this.$toast.open({
          duration: 2000,
          message: 'Заполните все поля, номер карты так же необходим',
          position: 'is-bottom',
          type: 'is-danger'
        })
      },
      ws_on_message: function (message) {
        message = JSON.parse(message)
        var method = message.method
        var params = message.params
        if (method === 'reader_read') this.reader_read(params)
      },
      reader_read: function (params) {
        var cnumber = params.card_number
        this.reader_target.number = cnumber
        this.is_waiting_for_card = false
        this.reader_target = null
        console.log(cnumber)
      },
      reset_new_form: function () {
        this.new_car = JSON.parse(JSON.stringify(this.empty_new_car))
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .is-margin-bottom {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cars.vue